import React from "react";
import { useNavigate } from "react-router-dom";

import { AgentsPanel } from "./AgentsPanel";
import { plugIcon } from "./plugIcon";

export {
  CONNECT_PROMPT,
  CLAUDE_CODE_ADD,
  CLAUDE_CODE_LOGIN,
} from "./AgentsPanel";

/**
 * `/agents`: the deep link the setup page and the consent flow point at. The
 * same body opens as a drawer inside the editor (`AgentsSidebar`); this route
 * stays so an agent can name one stable URL.
 */

const BackIcon = (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M15 18l-6-6 6-6" />
  </svg>
);

export const AgentsPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    // The global stylesheet locks `html, body` to `overflow: hidden` for the
    // canvas, so the page is its own scroll container (as My Files is).
    <div className="agents" data-testid="agents-page">
      <header className="agents__top">
        <button
          type="button"
          aria-label="Back"
          title="Back"
          className="agents__back"
          onClick={() => navigate("/")}
        >
          {BackIcon}
        </button>
        <span className="agents__mark" aria-hidden="true">
          {plugIcon}
        </span>
        <h1 className="agents__title">Agents</h1>
      </header>
      <main className="agents__column">
        <AgentsPanel context="page" />
      </main>
    </div>
  );
};

export default AgentsPage;
